/**
 * Artifact keys for Virtual Teacher Assistant / knowledge-setup flow.
 * Must match router state consumed by knowledge-setup (`history.state.artifact`).
 */
export const ASSISTANT_ARTIFACT_KEYS = [
  'songs',
  'rhymes',
  'activities',
  'games',
  'stories',
] as const;

export type AssistantArtifactId = (typeof ASSISTANT_ARTIFACT_KEYS)[number];

/** Icon paths relative to `assets/` (use with `/assets/...` in templates). */
export const ASSISTANT_ARTIFACT_IMAGE_BY_ID: Record<AssistantArtifactId, string> =
  {
    songs: '/assets/icons/artifacts/songs.svg',
    rhymes: '/assets/icons/artifacts/rhyme.png',
    activities: '/assets/icons/artifacts/activities.svg',
    games: '/assets/icons/artifacts/games.svg',
    stories: '/assets/icons/artifacts/story.svg',
  };
